import SwipeableTextMobileStepper from './../Carousel/Carousel';

import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import { Box } from '@mui/system';
import * as React from 'react';

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default function CustomizedDialogs(props: { open: boolean; close: any; }) {
    const { open, close } = props

    const actualWidth = window.innerWidth;

    return (
        <Dialog
            onClose={close}
            open={open}
            maxWidth="xl"
        >

            <Box className='container grid grid-cols-2 space-x-4 ' sx={{ display: 'flex', flexDirection: ((actualWidth < 800) ? "column" : "row"), width: '950px', }}>
                <Box>
                    <SwipeableTextMobileStepper />
                </Box>
                <Box >
                    <Box className='right-0'>
                        <BootstrapDialogTitle id="customized-dialog-title" onClose={close}></BootstrapDialogTitle>
                    </Box>
                    <Box className=' relative inset-x-0'>
                        <Box className=' p-10 ' sx={{ marginLeft: 'auto', marginRight: 'auto', width: '550px' }}>
                            <p className='text-5xl'>Des ambiances uniques</p>
                           <p className='text-lg mt-5'> Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            Praesent dignissim nec turpis ac porta. Mauris sed hendrerit eros.
                            Praesent efficitur urna sed sodales pulvinar. Vestibulum malesuada id augue in tristique.
                            Proin hendrerit ornare diam eget consectetur. Cras eget sollicitudin ipsum.
                            Vivamus tempor dignissim orci, eu faucibus tortor volutpat gravida.
                            Sed eget augue eu magna congue facilisis vitae aliquam sapien. Sed vehicula mi at magna bibendum sodales. </p>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
}